import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var hamburger = {
    selector: '.hamburger',
    init: function() {
        var self = this,
            $hamburger = jQuery( self.selector + ', .navigation__bgMobile' ),
            $navigation = jQuery( '.navigation' );

        var navigation = document.querySelector( '.navigation__container' );

        $hamburger.on( 'click', function( e ) {
            $navigation.addClass( 'navigation--animate' );
            jQuery( document.body ).toggleClass( 'navigation-opened' );

            if ( jQuery( document.body ).hasClass( 'navigation-opened' ) ) {
                disableBodyScroll( navigation, { reserveScrollBarGap: true } );
                var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
            } else {
                enableBodyScroll( navigation );
            }
        } );


        jQuery('.submenu-toggle').on( 'click', function( e ) {
            jQuery(this).parent().children('ul').slideToggle('fast');
            jQuery(this).next('ul').addClass('active');
            jQuery(this).toggleClass('active');

        } );
        
        /*
        jQuery( window ).on( 'resize', function( e ) {
            $navigation.removeClass( 'navigation--animate' );
            jQuery( document.body ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );
        */

        $navigation.find( 'a').on( 'click', function() {
            jQuery( document.body ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );
    }
}

export {
    hamburger
};
